
import { defineComponent, ref } from 'vue'

// > types <
import type { MAnalyticGlobalSearchItem } from '@/modern/modules/m-analytics-module/services/types/analytics'

// > services <
import analyticsAPI from '@/modern/modules/m-analytics-module/services/analytics.service'

// > components <
import SearchItem from './SearchItem.vue'
import SearchState from './SearchState.vue'

// > legacy/vue-composable <
import { useDebounce } from 'vue-composable'

export default defineComponent({
    name: 'bs-invoice-search',
    components: {
        SearchItem,
        SearchState,
    },
    setup() {
        const is_loading = ref(false)
        const is_loaded = ref(false)
        const is_failed = ref(false)

        const query = ref<string | null>(null)
        const items = ref<Array<MAnalyticGlobalSearchItem>>([])

        const onSearch = async () => {
            is_loaded.value = false

            if (!query.value) {
                query.value = null
                items.value = []

                is_loading.value = false
                is_failed.value = false

                return
            }

            try {
                is_loading.value = true

                const response = await analyticsAPI.globalSearch({ name: query.value })
                items.value = response.data.data

                is_failed.value = false
            } catch (error) {
                console.error(error)
                is_failed.value = true
            } finally {
                is_loading.value = false
                is_loaded.value = true
            }
        }

        const debouncedSearch = useDebounce(onSearch, 500)

        const onReset = () => {
            query.value = null
            items.value = []
        }

        return {
            is_loading,
            is_loaded,
            is_failed,
            query,
            items,
            debouncedSearch,
            onReset,
        }
    }
})
